export default "__VITE_ASSET__RmuU2j9V__"